module.exports = __webpack_public_path__ + "assets/img/4.2f08810c.jpg";